module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('banner', {
    attrs: {
      "items": _vm.items
    }
  }), _vm._v(" "), _c('fix-nav', {
    attrs: {
      "currentIndex": _vm.currentIndex
    },
    on: {
      "switch": _vm.switchItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('switches', {
    attrs: {
      "switches": _vm.switches,
      "currentIndex": _vm.currentIndex,
      "para": _vm.para
    },
    on: {
      "switch": _vm.switchItem
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "site-main"
    }
  }, [(_vm.currentIndex === 0) ? _c('market') : _vm._e(), _vm._v(" "), (_vm.currentIndex === 1) ? _c('consultation') : _vm._e()], 1), _vm._v(" "), _c('t-footer', {
    attrs: {
      "infos": _vm.infos
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afb9a044","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/training.vue
// module id = 465
// module chunks = 1